export const GA_TRACKING_ID = process.env.GA_TRACKING_ID;

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageview = (url) => {
  console.log("🚀 ~ file: gtag.js ~ line 5 ~ pageview ~ url", url);
  if (!window.gtag) return;
  window.gtag('config', GA_TRACKING_ID, {
    page_path: url,
  });
};

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
// payload can be in format { event_category, event_label, value }
export const event = ({ action, payload }) => {
  if (!window.gtag) return;
  console.log('gtag.event', action, payload);
  window.gtag('event', action, payload);
};
